module.exports = __webpack_public_path__ + "img/08219203000690.8de0b9c6.png";